import adserver, { AxiosError } from 'services/adserver';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { monitoringKeys } from './monitoring.keys';
import { MonitoringProposalOverview } from './monitoring.types';

const getCampaignProposalsOverview = async (
  campaignId: number,
): Promise<MonitoringProposalOverview[]> => {
  const { data } = await adserver({
    url: `/campaign/${campaignId}/monitoring/proposals`,
    headers: {},
  });

  return data;
};

export const useGetCampaignProposalsOverview = (
  campaignId: number,
): UseQueryResult<MonitoringProposalOverview[], AxiosError> => {
  return useQuery<MonitoringProposalOverview[], AxiosError>({
    queryKey: monitoringKeys.campaignProposals(campaignId),
    queryFn: () => getCampaignProposalsOverview(campaignId),
    enabled: !!campaignId,
  });
};
